import _bundle from '../../core/core--bundles';

const createTabs = () => {
  $('#tabButtons').kendoButtonGroup({
    items: [
      { text: 'Overview', attributes: { id: 'overviewButton', class: 'k-flat tab', 'data-role': 'showTab', 'data-view': 'overview' } },
      { text: 'Finance', attributes: { id: 'financeButton', class: 'k-flat tab', 'data-role': 'showTab', 'data-view': 'finance'  }, selected: true }
    ]
  });
  $('[data-role-name="overview"]').toggle();
};

const showTab = (event) => {
  const {name} = event.data;
  const allTabs = $('[data-role="tab"]');
  const visibleTab = allTabs.find(`[data-role-name="${name}"]:visible`);
  if(visibleTab.attr('data-role-name') !== name) allTabs.toggle();
};

const loadTab = (tabName) => {
  const tabSelector = `div[data-role="tab"]`;
  const tabShowSelector = `${tabSelector}[data-view="${tabName}"]`;
  const tabShow = $(tabShowSelector);
  $(tabSelector).toggle(false);
  tabShow.toggle(true);
};

const addActions = () => {
  const overview = $('#overviewButton');
  const finance = $('#financeButton');
  overview.click({ name: 'overview' }, showTab);
  finance.click({ name: 'finance' }, showTab);
};

const setupTabs = () => {
  const tabBase = $('a.menu-topbar__link');
  tabBase.click(function (e) {
    const that = $(this);
    const parents = tabBase.parent();
    const thoseParents = that.parent();
    tabBase.removeClass('--active');
    tabBase.prop('disabled', true);
    parents.removeClass('--active');
    that.addClass('--active');
    thoseParents.addClass('--active');
    $(document).trigger('on:TabChange');
  });
}

export default function() {
  setupTabs();
  _bundle.add({
    name: 'Project Overview: Change Tabs',
    event: ['on:TabChange'],
    fn() {
      const activeTabName = $('.menu-topbar__link.--active').text();
      loadTab(activeTabName);
    }
  });
};
